import React from 'react';
import styled from "styled-components";
import BlogCard from './BlogCard';
import blog1 from "./Images/7.jpeg"
import blog3 from "./Images/LBS-mamamoni.jpg"
import blog2 from "./Images/afrihack.jpg"
import blog4 from "./Images/MainLBS.JPG"
import blog6 from "./Images/10.jpeg"
import set05 from "./Images/set05.jpg"
import shecodes from "./Images/shecodes.JPG";
import presentation from "./Images/set01.JPG";

const Blog = () => {
  return (
    <Container>
      <Wrapper>
        <BlogCard image={blog1} description="Thursday fitness exercises for developers to stay ift and healthy all week for great coding experience" title="#Fit4Dev"/>
        <BlogCard image={blog2} description="Naija SDG Hackathon and sustainable finance day" title="Naija SDG Hachathon"/>
        <BlogCard image={blog3} description="Live at the 2023 tech founders summit.Spot Mamamoni by my left and Naza at my right" title="Tech Founders Summit 2023"/>
        <BlogCard image={blog4} description="First Panelist Session" title="Tech Founders Summit 2023"/>
        <BlogCard image={blog6} description="Ajegunle Tech Fair featuring CodeLab" title="Ajegunle Tech Fair"/>
        <BlogCard image={set05} description="Codelab set05 at the Ajegunle Techfair 1.0" title="Codelab Set05"/>
        <BlogCard image={presentation} description="Mamamoni coding class set 1.0 project presentation" title="Project presentation"/>
        <BlogCard image={shecodes} description="ShecodesAj Tech Fair: 2days training ladies/girls on HTML/CSS" title="SheCodes Aj Tech Forum"/>
        <BlogCard image={blog1} description="ShecodeAj out on athursday fitness" title="ShecodeAj Fit4Dev"/>
        {/* <BlogCard image={blog1} description="For 11" title="11"/> */}
      </Wrapper>
    </Container>
  )
};

export default Blog;

const Container = styled.div`
width: 100%;
height: auto;
background:black;
display: flex;
justify-content: center;
align-items: center;
padding: 90px 0 0 0;
z-index: 1;
top: 0;
`;
const Wrapper = styled.div`
width: 100%;
height: 90%;
/* background-color: rebeccapurple; */
display: flex;
flex-wrap: wrap;
justify-content: center;
`;